<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span> Imagery Implementation </span>
    <span class="example-spacer"></span>

    <a mat-button
       aria-label="GitHub Repository"
       target="_blank"
       [href]="LINK_TO_GITHUB">
      <img alt="github" src="assets/forkme.svg" />
    </a>

  </mat-toolbar-row>

</mat-toolbar>
